import { WithTheme } from '@issuemanager/apps/client/theme';
import { Link, LinkProps, Stack, Typography, styled } from '@mui/material';
import { JSX, useMemo } from 'react';

type Props = {
  label: string;
  number?: number;
  onClick: () => void;
  isActive: boolean;
  testId?: string;
};

const StyledLink = styled(Link)<WithTheme<LinkProps>>(({ theme }) => ({
  cursor: 'pointer',
  fontWeight: theme.typography.fontWeightRegular,
}));

const StyledStack = styled(Stack)<WithTheme<{ isActive: Props['isActive'] }>>(
  ({ theme, isActive }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: isActive
      ? `${theme.tokens.semantic.color.transparent.hover.value}`
      : '',
  }),
);

const StyledTypography = styled(Typography)<{ number: Props['number'] }>(
  ({ number }) => ({
    fontSize: 20,
    fontWeight: 'semi-bold',
    visibility: number === undefined ? 'hidden' : 'visible',
  }),
);

export function QuickFilterItem({
  label,
  number,
  onClick,
  isActive,
  testId,
}: Props): JSX.Element {
  const memorizedTypography = useMemo(
    () => <StyledTypography number={number}>{number}</StyledTypography>,
    [number],
  );

  return (
    <StyledStack
      gap={1}
      isActive={isActive}
      data-testid={testId ?? label.toLowerCase().replace(/\s+/g, '-')}
    >
      <StyledLink onClick={onClick}>{label}</StyledLink>
      {memorizedTypography}
    </StyledStack>
  );
}
